import React, { useState } from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';

// import Loading from '../../../../../../lib/layout/loading';
// import Error from '../../../../../../lib/layout/error';
import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';

// import { QUERY_STATE, CALCULATE_PREMIUM } from '../../queries';
import{QUERY_STATE,
  CALCULATE_PREMIUM,
  INTERMEDIARY_LIST,
  LOOKUP_FIELDUSER,}  from 'quanta-flows/modules/quote/health';

import {
  updateHealthQuotePlansPremium,
  removeEntirePack,
  addEntirePack,
  toggleAddOn,
  updateSelectedPlans,

} from 'quanta-flows/modules/quote/health/state';

// import { updateBuyHealthPolicy } from '../../../../new-policy-issuance/health/_graphql/state';
import { updateBuyHealthPolicy } from 'quanta-flows/modules/proposal/health/state';


import {
  Checkbox,
  Toggle,
  Paper,
  DataGrid,
  Grid,
  GridItem,
  Button,
  Text,
  useResponsiveParams,
  NotificationList,
  Modal,
} from 'quanta-ui';

import {
  faChevronRight,
  faCheck,
  faChevronCircleUp,
  faChevronCircleDown,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import ShowPremium from './show-premium';
import { ShowPremium } from 'quanta-flows/modules/quote/health';

import {ModalViewBreakupHealth} from 'quanta-flows/modules/common/viewBreakUp';

import {CurrencyFormater} from 'quanta-flows';
// import { useFetchCacheQuery } from 'quanta-flows';
import { useFetchQuery } from 'quanta-flows';

function RenderPlan({
  id,
  plan,
  plans,
  quote,
  plansChanged,
  setShowViewBreakup,
  alerts,
  setAlerts,
  setSelectedPlanTypeView,
  quoteNumber,
  productName,
  productCode,
  lobCode,
  selectedIntermediary,
  setShowViewBaseCovers,
  setCurrentPlan,
  saveProceedDisplay
}) {
  let repeatForMobile = 2;
  let repeatForDesktop = 4;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  const fetchQuery = useFetchQuery();

  const [expanded, setExpanded] = useState([]);
  const [initLoad, setInitLoad] = useState(true);
  const [resultPremiumError, setResultPremiumError] = useState(false);
  const [isProceeding, setProceeding] = useState(false);
  
  const history = useHistory();
  const showPackCheckbox = false;
  const atLeastOneAddOnSelected = (addOn) => {
    return addOn.map((add) => add.selected).includes(true);
  };

  const getGraphQLErrorMessage = (error) => {
    return error.graphQLErrors.length > 0
      ? error.graphQLErrors.map((gerr) =>
          gerr && gerr.message
            ? gerr.message
            : 'Internal Error Occurred',
        )[0]
      : error.message
      //Unexpected Token
      ? error.message.includes("Unexpected token") ?
      'Please try again after sometime' : 
      error.message
      : 'Internal Error Occurred';
    //Unexpected Token
  };

  const getAddOnCovers = (rel) => {
    let addOnCoverArr = [];
    plan?.packs.forEach((pack) => {
      if (pack.index.includes(rel)) {
        pack.addOnCovers.forEach((addOn) => {
          if (addOn.selected) {
            addOnCoverArr.push({
              name: addOn.name,
              index: addOn.index,
            });
          }
        });
      }
    });

    return addOnCoverArr;
  };

  const variables = {
    input: {
      members: quote.members
        .filter((m) => m.selected)
        .map((mem) => {
          return {
            relationship: mem.relationship,
            gender: mem.gender,
            dob: mem.dob,
            age: mem.age.toString(),
            addOnCovers: getAddOnCovers(mem.relationship),
          };
        }),
      businessType: quote.quotationType,
      intermediary: {
        intermediaryCode:
          selectedIntermediary?.intermediaryCode ||
          quote?.intermediaryDetails?.code,
        locationCode:
          selectedIntermediary?.branchOfficeCode ||
          quote?.intermediaryDetails?.location,
        fieldUserCode:
          selectedIntermediary?.fieldUserCode ||
          quote?.intermediaryDetails?.fieldUserCode,
      },
      startDate: moment().format('DD/MM/YYYY').toString(),
      startTime: '00:00',
      plan: {
        name: plan.name,
        code: plan.code,
      },
      zone: quote.location.zone,
      coverType: quote.cover.type,
      sumInsured: parseInt(quote.cover.sum_insured),
      tenure: quote.cover.tenure,
      productCode: productCode,
      existingPolicyNumber: quote?.existingPolicyNumber,
      isExistingEmployee:
        quote?.isExistingEmployee?.toLowerCase() === 'yes'
          ? true
          : false,
      proposerPincode: quote?.location?.pincode,
    },
  };

  const { loading: premiumLoading, error: premiumError } = useQuery(
    CALCULATE_PREMIUM,
    {
      variables,
      skip: ((quoteNumber
        ? true
        : initLoad
        ? false
        : !plansChanged.includes(plan.name)) || quote?.quotationNo !== ''),
      onCompleted: (data) => {
        setInitLoad(false);
        setResultPremiumError(false);
        updateHealthQuotePlansPremium(
          plan.name,
          data.calculatePremium,
        );
        if (
          data?.calculatePremium?.warningMsg &&
          data?.calculatePremium?.warningMsg !== ''
        ) {
          setAlerts([
            ...alerts,
            {
              header: `Warning for Plan ${plan?.name}`,
              id: Date.now(),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full text-base">
                  <span>{data?.calculatePremium?.warningMsg}</span>
                </div>
              ),
              type: 'warning',
              timeout: null,
              disableClose: false,
            },
          ]);
        }
      },
      onError: (error) => {
        setResultPremiumError(true);
        setAlerts([
          ...alerts,
          {
            header: `Error for Plan ${plan.name}`,
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full text-base">
                <span>{getGraphQLErrorMessage(error)}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        updateSelectedPlans(plan?.name,false);
         //Unexpected Token
         if(error?.message){
          if(error.message.includes("Unexpected token")){
            error.message='Please try again after sometime'
          }
        }
      //Unexpected Token
      },
    },
  );

  const {
    loading: intermediaryListLoading,
    error: intermediaryListError,
    data: intermediaryListData,
  } = useQuery(INTERMEDIARY_LIST);

  const myIntermediaries = intermediaryListData
    ? intermediaryListData.myIntermediaries
    : null;

  const getIntermediaryName = (code) => {
    return myIntermediaries
      ? myIntermediaries?.find(
          (intermediary) => intermediary?.intermediaryCode === code,
        )?.intermediaryName
      : code;
  };

  const getBusinessLocation = (intermediarycode, locationCode) => {
    return myIntermediaries && intermediarycode && locationCode
      ? myIntermediaries?.find(
          (intermediary) =>
            intermediary?.intermediaryCode === intermediarycode,
        )
        ? myIntermediaries
            ?.find(
              (intermediary) =>
                intermediary?.intermediaryCode === intermediarycode,
            )
            ?.businessLocations.find(
              (location) => location?.code === locationCode,
            )?.name
        : locationCode
      : '';
  };

  const selectedCount = (pack) => {
    let count = 0;
    pack.addOnCovers.forEach((add) => {
      if (add.selected) {
        count = count + 1;
      }
    });
    return count;
  };

  const planCoverData = [
    quote?.captureMode === 'create'?
    {
      title: '',
      repeat: 1,
      grid_data: [{
        text: (
          <Checkbox
            label={
              <Text
                type={'normal'}
                className={
                  'h-full flex flex-col items-center mt-1'
                }
              >
                Select this plan for quote
              </Text>
            }            
            labelClassName={'text-base mb-2'} 
            checked={plan?.isSelected}
            disabled={(premiumError !== null && premiumError !== undefined) || (quote?.quotationNo !== '')}
            onChange={(val) => updateSelectedPlans(plan?.name,val)}
          />
        ),
        className: '-mb-2'
      }]
    }:null,
    {
      repeat: repeat,
      gapX: 4,
      gapY: 4,
      grid_data: [
        {
          label: <Text type="title" severity="info" >Plan Name</Text>,
          text: plan.name,
          severity: 'info',
          type: 'subtitle',
        },
        {
          label: <Text type="title" severity="info" >Sum Insured</Text>,
          text: CurrencyFormater(quote.cover.sum_insured),
          severity: 'info',
          type: 'normal',
        },
        {
          label:<Text type="title" severity="info"> {
            // repeat === repeatForMobile
            //   ? 'Annual Premium'
            //   : 'Annual Premium (inclusive of all taxes)'
            repeat === repeatForDesktop
            ? 'Annual Premium (inclusive of all taxes)'
            : 'Annual Premium'
            }</Text>,
          text: (
            <ShowPremium
              planName={plan.name}
              loading={premiumLoading}
              error={premiumError}
              setShowViewBreakup={setShowViewBreakup}
              setSelectedPlanTypeView={setSelectedPlanTypeView}
            />
          ),
          className: 'md:-ml-1',
        },
        {
          text: (
            <div className="mt-3">
              <Button
                className="md:w-48 md:pr-4 max-h-10"
                size="medium"
                iconPost={
                  isProceeding ? (
                    <FontAwesomeIcon
                      icon={faSpinner}
                      spin={true}
                      className="mr-4"
                    />
                  ) : repeat === repeatForDesktop ? (
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className="mr-4"
                    />
                  ) : null                  
                }
                onClick={async (_) => {
                  try {
                    if (
                      selectedIntermediary?.fieldUserCode !== '' ||
                      quote?.intermediaryDetails?.fieldUserCode !== ''
                    ) {
                      const associateEntityLookupQuery = fetchQuery({
                        query: LOOKUP_FIELDUSER,
                        variables: {
                          filter: {
                            fieldUserID: `${selectedIntermediary?.fieldUserCode ||
                            quote?.intermediaryDetails?.fieldUserCode
                          }`,
                          },
                        },
                      },
                      );
                      setProceeding(true);
                      const {
                        data: associateEntityLookupData,
                      } = await associateEntityLookupQuery;
                      setProceeding(false);
                      var {
                        associatedEntityLookup,
                      } = associateEntityLookupData;
                    }
                    if (quote?.customer?.id) {
                      updateBuyHealthPolicy({
                        insuredDetails: quote.members
                          .filter((m) => m.selected)
                          .map((m) => {
                            return {
                              relationship: m.relationship,
                            };
                          }),
                        nomineeDetails: quote.members
                          .filter((m) => m.selected)
                          .map((m) => {
                            return {
                              relationship: m.relationship,
                            };
                          }),
                        proposerDetailsMeta: quote?.customerMeta,
                        proposerDetails: quote?.customer,
                        customerFetchRequiredOnLoad: true,
                        isQuoteSaved: true,
                        quoteData: quote,
                        planData: plans,
                        quotationType: quote.quotationType,
                        quoteNumber: quote.quotationNo,
                        quoteStatus: quote.quotationStatus,
                        existingPolicyNumber:
                          quote.existingPolicyNumber,
                        isExistingEmployee: quote.isExistingEmployee,
                        intermediaryDetails: {
                          code:
                            selectedIntermediary?.intermediaryCode ||
                            quote?.intermediaryDetails?.code,
                          intermediaryName:
                            getIntermediaryName(
                              quote?.intermediaryDetails?.code ||
                                selectedIntermediary?.intermediaryCode,
                            ) ||
                            selectedIntermediary?.intermediaryName,
                          location:
                            selectedIntermediary?.branchOfficeCode ||
                            quote?.intermediaryDetails?.location,
                          branchOfficeName:
                            getBusinessLocation(
                              quote?.intermediaryDetails?.code ||
                                selectedIntermediary?.intermediaryCode,
                              quote?.intermediaryDetails?.location ||
                                selectedIntermediary?.branchOfficeCode,
                            ) ||
                            selectedIntermediary?.branchOfficeName,
                          fieldUserCode:
                            selectedIntermediary?.fieldUserCode ||
                            quote?.intermediaryDetails?.fieldUserCode,
                          fieldUserName:
                            selectedIntermediary?.fieldUserName ||
                            quote?.intermediaryDetails?.fieldUserName
                              ? selectedIntermediary?.fieldUserName ||
                                quote?.intermediaryDetails
                                  ?.fieldUserName
                              : selectedIntermediary?.fieldUserCode ||
                                quote?.intermediaryDetails
                                  ?.fieldUserCode
                              ? associatedEntityLookup?.fieldUserName
                              : quote?.intermediaryDetails
                                  ?.fieldUserCode === ''
                              ? ''
                              : '',
                        },
                      });
                    } else {
                      updateBuyHealthPolicy({
                        insuredDetails: quote.members
                          .filter((m) => m.selected)
                          .map((m) => {
                            return {
                              relationship: m.relationship,
                            };
                          }),
                        nomineeDetails: quote.members
                          .filter((m) => m.selected)
                          .map((m) => {
                            return {
                              relationship: m.relationship,
                            };
                          }),
                        proposerDetailsMeta: quote?.customerMeta,
                        proposerDetails: quote?.customer,
                        customerFetchRequiredOnLoad: true,
                        isQuoteSaved: quote?.customer?.customerType
                          ? true
                          : false,
                        quoteData: quote,
                        planData: plans,
                        quotationType: quote.quotationType,
                        quoteNumber: quote.quotationNo,
                        quoteStatus: quote.quotationStatus,
                        existingPolicyNumber:
                          quote.existingPolicyNumber,
                        isExistingEmployee: quote.isExistingEmployee,
                        intermediaryDetails: {
                          code:
                            selectedIntermediary?.intermediaryCode ||
                            quote?.intermediaryDetails?.code,
                          intermediaryName:
                            getIntermediaryName(
                              quote?.intermediaryDetails?.code ||
                                selectedIntermediary?.intermediaryCode,
                            ) ||
                            selectedIntermediary?.intermediaryName,
                          location:
                            selectedIntermediary?.branchOfficeCode ||
                            quote?.intermediaryDetails?.location,
                          branchOfficeName:
                            getBusinessLocation(
                              quote?.intermediaryDetails?.code ||
                                selectedIntermediary?.intermediaryCode,
                              quote?.intermediaryDetails?.location ||
                                selectedIntermediary?.branchOfficeCode,
                            ) ||
                            selectedIntermediary?.branchOfficeName,
                          fieldUserCode:
                            selectedIntermediary?.fieldUserCode ||
                            quote?.intermediaryDetails?.fieldUserCode,
                          fieldUserCode:
                            selectedIntermediary?.fieldUserCode ||
                            quote?.intermediaryDetails?.fieldUserCode,
                          fieldUserName:
                            selectedIntermediary?.fieldUserName ||
                            quote?.intermediaryDetails?.fieldUserName
                              ? selectedIntermediary?.fieldUserName ||
                                quote?.intermediaryDetails
                                  ?.fieldUserName
                              : selectedIntermediary?.fieldUserCode ||
                                quote?.intermediaryDetails
                                  ?.fieldUserCode
                              ? associatedEntityLookup?.fieldUserName
                              : '',
                        },
                      });
                    }
                    history.push(
                      `/quote/health/buy/${lobCode}/${productName}/${productCode}/${plan?.code}/${plan?.name}`,
                    );
                  } catch (error) {
                    setProceeding(false);
                    setAlerts([
                      ...alerts,
                      {
                        header: `Intermediary details fetch failed`,
                        id: Date.now(),
                        content: (
                          <div className="flex flex-row flex-wrap space-y-2 w-full h-full text-base">
                            <span>
                              {getGraphQLErrorMessage(error)}
                            </span>
                          </div>
                        ),
                        type: 'error',
                        timeout: null,
                        disableClose: false,
                      },
                    ]);
                  }
                }}
                disabled={
                  ((quote.proposalNumber !== ''
                    ? true
                    : quoteNumber
                    ? false
                      : premiumLoading || resultPremiumError) || quote?.isQuoteSaving
                    // ||saveProceedDisplay  
                  )
                }
              >
                Proceed to Buy
              </Button>
            </div>
          ),
        },
      ],
    },
    {
      title: (
        <div className="flex flex-col md:flex-row md:items-center -mb-3">
          <span className={'h-full flex flex-row space-x-2 items-center'}>
            <span className={'bg-primary rounded-full w-8 h-8 text-white flex items-center text-center justify-center'}>{plan?.covers?.length}</span>
            <Text severity={'dark'}>base covers included in this plan</Text>
          </span>
          <span className="h-full">
            <Text
              severity="action"
              type="label"
              className="-ml-2 md:ml-1 quanta_link cursor-pointer h-1"
              onClick={(e) => {
                setCurrentPlan(plan);
                setShowViewBaseCovers(true);
              }}
            >
              View Base Covers
            </Text>
          </span>
        </div>
      ),
      titleType: 'title',
      titleSeverity: 'info',
      grid_data: [],
    },
    
    {
      title:
        plan.packs.length > 0 ? (
          <div
            className="mt-2 pt-2 border-t border-primary text-secondary text-base cursor-pointer"
            onClick={(e) =>
              expanded.includes(id)
                ? setExpanded(expanded.filter((exp) => exp !== id))
                : setExpanded([...expanded, id])
            }
          >
            Add-on Covers
            <FontAwesomeIcon
              icon={
                expanded.includes(id)
                  ? faChevronCircleUp
                  : faChevronCircleDown
              }
              className="text-secondary ml-2 cursor-pointer"
            />
          </div>
        ) : null,
      titleType: 'normal',
      repeat: 1,
      grid_data: expanded.includes(id)
        ? plan.packs.map((pack, idx) => {
            return {
              label: showPackCheckbox ? (
                <Checkbox
                  label={pack.name}
                  labelClassName="text-base"
                  checked={atLeastOneAddOnSelected(pack.addOnCovers)}
                  onChange={(val) =>
                    val
                      ? addEntirePack(pack.name, plan.name)
                      : removeEntirePack(pack.name, plan.name)
                  }
                />
              ) : (
                <Text>
                  {pack.name}{' '}
                  {selectedCount(pack) > 0
                    ? `(${selectedCount(pack)} selected)`
                    : null}
                </Text>
              ),
              text: (
                <Grid
                  className="mt-2 font-normal break-normal"
                  repeat={repeat}
                  gap={1}
                >
                  {pack.addOnCovers.map((add, idx) => (
                    <Toggle
                      key={idx}
                      label={add.name}
                      labelType="label"
                      checked={add.selected}
                      disabled={quote.quotationNo !== ''}
                      onChange={() =>
                        toggleAddOn(add.name, pack.name, plan.name)
                      }
                    />
                  ))}
                </Grid>
              ),
            };
          })
        : [],
    },
  ]?.filter((d) => d);

  return (
    <Paper>
      {intermediaryListLoading && <Loading />}
      {intermediaryListError && <Error />}
      {!intermediaryListLoading && !intermediaryListError && (
        <div>
          <Grid repeat={1} gapY={2}>
            {planCoverData.map((planCover, idx) => (
              <DataGrid
                key={idx}
                repeat={planCover?.repeat}
                gapX={planCover?.gapX}
                gapY={planCover?.gapY}
                title={planCover?.title}
                titleType={planCover?.titleType}
                titleSeverity={planCover?.titleSeverity}
                textType={planCover?.textType}
                data={planCover.grid_data}
              />
            ))}
          </Grid>
        </div>
      )}
    </Paper>
  );
}

export default function ShowPlans({
  planLoading,
  planError,
  genderList,
  productName,
  productCode,
  lobCode,
  quoteNumber,
  selectedIntermediary,
  saveProceedDisplay
}) {
  let repeatForMobile = 1;
  let repeatForDesktop = 2;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });

  const [selectedPlanTypeView, setSelectedPlanTypeView] =
    useState(undefined);
  const [showViewBreakup, setShowViewBreakup] = useState(false);
  const [showViewBaseCovers, setShowViewBaseCovers] = useState(false);
  const [currentPlan, setCurrentPlan] = useState();
  const [alerts, setAlerts] = useState([]);
  const { data: queryStateData } = useQuery(QUERY_STATE);

  const { healthQuote, healthPlans } = queryStateData;

  if (planLoading)
    return (
      <div className="min-h-screen">
        <Loading customMessage="Looking for suitable plans" />
      </div>
    );
  if (planError) {
    let error = {
      message: `There was an issue fetching the Plan and Cover Details. Please try again after some time...`,
    };
    return <Error error={error} />;
  }

  let { plans, plansChanged,selectedPlans } = healthPlans;

  return plans.length > 0 ? (
    <div
      id="planSection"
      className="mt-4 border-t border-neutral-dark"
    >
      <div className="flex items-center justify-between mt-4 mb-2">
        <Text type="title" severity="info">
          {`We have found ${plans.length} plan${
            plans.length > 1 ? '(s)' : ''
          } for your selection`}
        </Text>
      </div>
      <Grid repeat={1} gapY={4}>
        {plans.map((plan, idx) => (
          <RenderPlan
            key={idx}
            id={idx}
            plan={plan}
            plans={healthPlans}
            quote={healthQuote}
            plansChanged={plansChanged}
            setShowViewBreakup={setShowViewBreakup}
            alerts={alerts}
            setAlerts={setAlerts}
            setSelectedPlanTypeView={setSelectedPlanTypeView}
            quoteNumber={quoteNumber}
            productName={productName}
            lobCode={lobCode}
            productCode={productCode}
            selectedIntermediary={selectedIntermediary}
            setShowViewBaseCovers={setShowViewBaseCovers}
            setCurrentPlan={setCurrentPlan}
            saveProceedDisplay={saveProceedDisplay}
          />
        ))}
      </Grid>
      {selectedPlanTypeView ? (
        <ModalViewBreakupHealth
          {...{
            showViewBreakup,
            setShowViewBreakup,
            selectedPlanTypeView,
            productName,
            productCode,
            lobCode,
            quoteNumber,
            genderList,
            reactive_var_quote: healthQuote,
            reactive_var_plan: healthPlans,
            title: 'Premium Breakup for Quote',
          }}
        />
      ) : null}
       {currentPlan ? (
        <div className="text-black font-normal">
          <Modal
            display={showViewBaseCovers}
            size={repeat === repeatForMobile ? 'full' : 'medium'}
            className={
              repeat === repeatForMobile
                ? 'h-screen flex flex-col'
                : ''
            }
            title={`Base Covers for ${currentPlan?.name}`}
            onClose={(e) => setShowViewBaseCovers(false)}
          >
            <Grid repeat={repeat} gap={2}>
              {currentPlan?.covers.map((cover, idx) => (
                <GridItem key={idx}>
                  <div className="flex flex-row space-x-1 items-center">
                    <div className="text-success">
                      <FontAwesomeIcon icon={faCheck} />
                    </div>
                    <Text type="label">{cover.name}</Text>
                  </div>
                </GridItem>
              ))}
            </Grid>
          </Modal>
        </div>
      ) : null}
      <NotificationList {...{ items: alerts }} />
    </div>
  ) : (
    <div></div>
  );
}
